<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "ORDER_MATERIALS.TITLE" | translate }}
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <div
        class="gt2-light-green flex-row-center-center"
        style="width: 60px; height: 56px"
      >
        <button
          type="button"
          matTooltip="{{ 'ORDER_MATERIALS.CREATE_PRODUCT' | translate }}"
          mat-icon-button
          (click)="onCreateProduct()"
        >
          <mat-icon class="icon-mat-black">add</mat-icon>
        </button>
      </div>
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body">
    <div class="flex-column">
      <mat-form-field floatLabel="auto" class="mr-4 fxFlexAuto">
        <mat-label>{{
          "ORDER_MATERIALS.SEARCH" | translate | ucfirst
        }}</mat-label>
        <input #filter id="search" [(ngModel)]="filterValue" matInput />
        <mat-icon
          *ngIf="filterValue"
          matSuffix
          mat-icon
          (click)="loadProductList()"
          >search</mat-icon
        >
        <mat-icon *ngIf="filterValue" matSuffix mat-icon (click)="clearSearch()"
          >close</mat-icon
        >
      </mat-form-field>

      <!-- Filtres additionnels : catégorie de matériel + tags. Utilisables avec
           ou sans mot-clé (un filtre actif suffit à lancer la recherche). -->
      <div class="material-filters-row flex-row-start-center">
        <p-dropdown
          [options]="materialCategories"
          [(ngModel)]="selectedCategoryUuid"
          (onChange)="onMaterialFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          [filter]="true"
          placeholder="{{ 'ORDER_MATERIALS.CATEGORY_FILTER' | translate }}"
          [style]="{ minWidth: '220px' }"
        ></p-dropdown>
        <p-multiSelect
          *ngIf="availableTags.length > 0"
          [options]="availableTags"
          [(ngModel)]="selectedTagUuids"
          (onChange)="onMaterialFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          placeholder="{{ 'ORDER_MATERIALS.TAGS_FILTER' | translate }}"
          selectedItemsLabel="{0} tags"
          [style]="{ minWidth: '180px' }"
        >
          <ng-template let-tag pTemplate="item">
            <div class="flex-row-start-center" style="gap: 8px">
              <span class="tag-color-dot" [ngClass]="tag.color"></span>
              {{ tag.name }}
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      @if (!isSmallScreen) {
        <div class="flex-row fxLayout-column-xs" style="margin-bottom: 16px">
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_MATERIALS.LEFT_LIST_LABEL" | translate }}
            </div>
          </div>
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_MATERIALS.RIGHT_LIST_LABEL" | translate }}
            </div>
          </div>
        </div>
      }

      <div cdkDropListGroup class="flex-row fxLayout-column-xs">
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_MATERIALS.LEFT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #productList
            cdkDropList
            [cdkDropListData]="materials"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
            ngxDroppable="example-target"
          >
            <div
              *ngIf="isLoading"
              class="flex-column-center-center fxFlex-100p"
            >
              <mat-spinner [diameter]="28" class=""></mat-spinner>
            </div>

            <div
              *ngIf="showSearchMaterialHint"
              class="flex-column-center-center fxFlex-100p"
            >
              {{ "ORDER_MATERIALS.SEARCH_MATERIAL" | translate }}
            </div>

            <div
              *ngIf="showNoSearchResults"
              class="flex-column-center-center fxFlex-100p"
            >
              <div>{{ "ORDER_MATERIALS.NO_SEARCH_RESULTS" | translate }}</div>
              <div>
                {{ "ORDER_MATERIALS.NO_SEARCH_RESULTS_TRY_AGAIN" | translate }}
              </div>
            </div>

            @for (material of materials; track material; let i = $index) {
              <div
                *ngIf="!isLoading"
                matRipple
                [cdkDragData]="material"
                cdkDrag
                [cdkDragDisabled]="mobileLayout.isMobileLayout()"
                cdkDragHandle
              >
                <div class="product-child-item flex-row-space-between-center">
                  <div class="flex-row-start-center">
                    <mat-icon
                      *ngIf="!mobileLayout.isMobileLayout()"
                      class="mr-8"
                      >drag_handle</mat-icon
                    >
                    <!--                                    <div matTooltip="{{item.name + ' | ' + item.price_label}}" [matTooltipPosition]="'right'">{{item.name_internal}}</div>-->
                    <div style="min-width: 200px">
                      <div class="item-name-internal">
                        {{ material.name_internal }}
                      </div>
                      <div class="item-name">
                        {{
                          material.name +
                            " | " +
                            material.price_label +
                            (material.is_combo
                              ? " | " + ("GENERIC.MATERIAL_COMBO" | translate)
                              : "")
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="flex-row-end-center fxFlex-60">
                    <mat-icon
                      mat-icon
                      (click)="onAddItem(material, true)"
                      class="ml-8 icon-mat-dark"
                      >add</mat-icon
                    >
                    <mat-icon
                      matTooltip="{{ 'GENERIC.OPEN_NEW_TAB' | translate }}"
                      mat-icon
                      (click)="onOpenInNewTab(material)"
                      class="ml-8 mr-8 icon-mat-dark"
                      >{{ getIcon("NEW_TAB") }}</mat-icon
                    >
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "ORDER_MATERIALS.RIGHT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #comboList
            cdkDropList
            [cdkDropListData]="combo"
            (cdkDropListDropped)="onDrop($event)"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
            ngxDroppable="example-target"
          >
            @for (comb of combo; track comb; let i = $index) {
              <div
                matRipple
                [cdkDragData]="comb"
                cdkDrag
                [cdkDragDisabled]="mobileLayout.isMobileLayout()"
              >
                <div
                  class="product-child-item-right flex-row-space-between-center"
                >
                  <div class="flex-row-start-center">
                    <mat-icon
                      *ngIf="!mobileLayout.isMobileLayout()"
                      cdkDragHandle
                      class="mr-8 qty-drag-handle"
                      >drag_handle</mat-icon
                    >
                    <mat-form-field class="form-input-container qty-input">
                      <input
                        matInput
                        class="text-center"
                        type="text"
                        pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
                        [ngModel]="comb.qty"
                        (ngModelChange)="onItemQtyChange($event, comb)"
                        style="text-align: center"
                      />
                    </mat-form-field>
                    <div
                      matTooltip="{{ comb.name }}"
                      [matTooltipPosition]="'right'"
                      class="ml-16"
                      style="min-width: 200px"
                    >
                      {{ comb.name_internal }}
                    </div>
                  </div>

                  <div class="flex-row-end-center fxFlex-98">
                    <mat-icon (click)="onAddItem(comb, true)" class="ml-8"
                      >add</mat-icon
                    >
                    <mat-icon (click)="onLessItem(comb, i)" class="ml-8"
                      >remove</mat-icon
                    >
                    <mat-icon (click)="onRemoveItem(comb, i)" class="ml-8"
                      >delete</mat-icon
                    >
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div
          [ngClass]="
            isSmallScreen ? 'flex-row fxFlex-100p' : 'flex-row fxFlex-50p'
          "
        >
          &nbsp;
        </div>

        <div
          [ngClass]="
            isSmallScreen
              ? 'flex-row-end-start fxFlex-100p'
              : 'flex-row-end-start fxFlex-50p'
          "
        >
          <div *ngIf="combo && combo.length > 0" class="pr-4">
            {{ combo.length }}
            {{ combo && combo.length > 1 ? "items" : "item" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button
      mat-raised-button
      (click)="onSaveProducts()"
      [disabled]="isLoading"
      class="accent mr-16"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="close()"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
